(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["result-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('results-slider')) {
    class ResultsSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.rs__slide'));
        this.current = 0;
        this.userStopped = false;

        // Dots
        this.addEventListener('click', (e) => {
          const dot = e.target.closest('[data-go]');
          if (!dot) return;
          this.stopAutoplay(true);
          this.goTo(parseInt(dot.dataset.go, 10));
        });

        // Before/after drag on every slide
        this.querySelectorAll('.rs-compare').forEach((el) => this.initCompare(el));

        // Swipe between slides (on the text side, not the compare image)
        this.initSwipe();

        // Product thumbnails: stretch to the text height (CSS), keep square (here)
        this.initThumbs();

        // Autoplay
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && this.slides.length > 1 && !reduced) {
          this.startAutoplay();
          this.addEventListener('mouseenter', () => this.stopAutoplay());
          this.addEventListener('mouseleave', () => this.startAutoplay());
          this.addEventListener('focusin', () => this.stopAutoplay());
        }

        // Theme Editor: clicking a Slide block shows that slide
        this.onBlockSelect = (e) => {
          if (e.detail.sectionId !== this.dataset.sectionId) return;
          const i = this.slides.indexOf(e.target);
          if (i > -1) { this.stopAutoplay(true); this.goTo(i); }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.stopAutoplay(true);
        if (this.thumbObserver) this.thumbObserver.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      goTo(index) {
        const n = this.slides.length;
        const i = ((index % n) + n) % n;
        this.slides.forEach((slide, idx) => {
          const active = idx === i;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        this.querySelectorAll('[data-go]').forEach((dot) => {
          const on = parseInt(dot.dataset.go, 10) === i;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.current = i;
      }

      startAutoplay() {
        if (this.userStopped || this.timer) return;
        const speed = parseInt(this.dataset.speed, 10) || 6000;
        this.timer = setInterval(() => this.goTo(this.current + 1), speed);
      }

      stopAutoplay(permanent) {
        if (permanent) this.userStopped = true;
        clearInterval(this.timer);
        this.timer = null;
      }

      initCompare(el) {
        const range = el.querySelector('.rs-compare__range');
        let dragging = false;

        const set = (pct) => {
          const v = Math.max(0, Math.min(100, pct));
          el.style.setProperty('--pos', v + '%');
          if (range) range.value = v;
        };
        const fromPointer = (e) => {
          const r = el.getBoundingClientRect();
          set(((e.clientX - r.left) / r.width) * 100);
        };

        el.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          if (e.pointerType === 'mouse') e.preventDefault();
          dragging = true;
          el.setPointerCapture(e.pointerId);
          fromPointer(e);
          this.stopAutoplay(true);
        });
        el.addEventListener('pointermove', (e) => { if (dragging) fromPointer(e); });
        ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((t) =>
          el.addEventListener(t, () => { dragging = false; })
        );
        if (range) range.addEventListener('input', () => set(parseFloat(range.value)));
      }

      initThumbs() {
        const thumbs = this.querySelectorAll('.rs-product__img');
        if (!thumbs.length || !('ResizeObserver' in window)) return;
        this.thumbObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            const h = Math.round(entry.target.getBoundingClientRect().height);
            if (h > 0 && entry.target.style.width !== h + 'px') entry.target.style.width = h + 'px';
          });
        });
        thumbs.forEach((el) => this.thumbObserver.observe(el));
      }

      initSwipe() {
        let startX = null, startY = null;
        this.addEventListener('touchstart', (e) => {
          if (e.target.closest('.rs-compare')) { startX = null; return; }
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          const dy = e.changedTouches[0].clientY - startY;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            this.stopAutoplay(true);
            this.goTo(this.current + (dx < 0 ? 1 : -1));
          }
          startX = null;
        });
      }
    }
    customElements.define('results-slider', ResultsSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
